/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */


expocadfx.setupMiniMap = function() {
	'use strict';
	var config = expocadfx.config;
    var data = expocadfx.fxData;
	var Dialog = expocadfx.Dialog;
    var elemById = expocadfx.element.elementById;
    var fxStyle = expocadfx.styles;
    var txt = expocadfx.txt;
	var util = expocadfx.util;
	
	var dialogParams = {};
	
	function mapMovedHandler() {
		data.miniMap.window.removeEventListener( "Dialog_Moved", mapMovedHandler);
		data.userMovedMap = true;
    }
	
	
	dialogParams.title = txt.MINI_MAP;
	dialogParams.headerBackgroudColor = fxStyle.windowHeader.clrBg !== "" ? 
		fxStyle.windowHeader.clrBg : fxStyle.mainHeader.clrBg;
	dialogParams.headerBackground = (fxStyle.windowHeader.gradBg !== "") ? 
		fxStyle.windowHeader.gradBg : (fxStyle.windowHeader.clrBg === "") ?
			fxStyle.mainHeader.gradBg : "";
	dialogParams.headerTextColor = fxStyle.windowHeader.clrText !== "" ? 
		fxStyle.windowHeader.clrText : fxStyle.mainHeader.clrText;
	dialogParams.cancelLabel = null;
	dialogParams.width = config.MINI_MAP_WIDTH;
	dialogParams.height = config.MINI_MAP_HEIGHT;
	dialogParams.posX = data.viewportWidth - dialogParams.width - 4;
	dialogParams.posY = data.viewportHeight - data.headerHeight -
						elemById( "ftr").offsetHeight - dialogParams.height - 4; 
	dialogParams.draggable = true;

	data.miniMap = new Dialog( dialogParams, elemById("appContent"), elemById( "mask"));
	data.miniMap.window.setAttribute( "id", "minimap");
	util.removeClass( data.miniMap.content, "scrollbar");
	data.miniMap.content.style.overflow = "hidden";
	data.miniMap.window.style.display = "none";
		//user moved window, resize won't reposition it unless out of window
	data.miniMap.window.addEventListener( "Dialog_Moved", mapMovedHandler);
};
